export interface TachographDecodedDataInput {
    inMovement?: boolean;
    driverStatus?: string;
    cardStatus?: boolean;
    driverDaily9hExceedCount?: number;
    cumulativeWeeklyDrivingTime?: number;
    dailyDrivingTime?: number;
    weeklyDrivingTime?: number;
    timeUntilNewDailyRest?: number;
    timeUntilNewWeeklyRestPeriod?: number;
    nextBreakDuration?: number;
    remainingTimeUntilNextBreak?: number;
    remainingDrivingTime?: number;
    remainingShiftDrivingTime?: number;
    remainingWeeklyDrivingTime?: number;
    remainingTimeOfCurrentBreak?: number;
    timeUntilNextDrivingPeriod?: number;
    nextDrivingPeriodDuration?: number;
    driverIdLSB?: string;
    driverIdMSB?: string;
    driverName?: string;
    driverSurname?: string;
}
